(()=>{'use strict';
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
const setupFilms=()=>document.querySelectorAll('[data-nv-cinema]').forEach(root=>{
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const scenes=[...root.querySelectorAll('[data-scene]')],posters=[...root.querySelectorAll('[data-scene-poster]')],dots=[...root.querySelectorAll('[data-scene-to]')],video=root.querySelector('[data-nv-film]'),toggle=root.querySelector('[data-film-toggle]'),status=root.querySelector('[data-scene-status]');
 if(!scenes.length)return;
 let index=0,inView=false,userPaused=false,userStarted=false,mode='poster',timer,watchdog,pendingSeek=null,attempt=0,autoplayBlocked=false;
 if(video){video.muted=true;video.playsInline=true}
 const allowed=()=>inView&&!document.hidden&&!userPaused&&(!reduced.matches||userStarted);
 const label=running=>{toggle.setAttribute('aria-pressed',String(running));toggle.setAttribute('aria-label',running?toggle.dataset.pause:toggle.dataset.play)};
 const clearTimers=()=>{clearTimeout(timer);clearTimeout(watchdog)};
 const render=(next,announce=false)=>{
  index=(next+scenes.length)%scenes.length;root.dataset.scene=String(index+1);
  scenes.forEach((scene,i)=>{scene.classList.toggle('is-active',i===index);scene.setAttribute('aria-hidden',String(i!==index));scene.inert=i!==index});
  posters.forEach((poster,i)=>{poster.classList.toggle('is-active',i===index);poster.setAttribute('aria-hidden',String(i!==index))});
  dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
  if(announce)status.textContent=scenes[index].dataset.title;
 };
 const stop=()=>{attempt++;clearTimers();video?.pause();label(false)};
 const fallback=()=>{
  attempt++;clearTimers();mode='poster';root.dataset.playback='stills';video?.pause();video?.classList.remove('is-playing');label(allowed());
  if(allowed())timer=setTimeout(()=>{render(index+1);pendingSeek=Number(scenes[index].dataset.start);fallback()},6000);
 };
 const seek=()=>{if(video&&pendingSeek!==null&&video.readyState>=1){try{video.currentTime=pendingSeek;pendingSeek=null}catch{}}};
 const play=async()=>{
  if(!allowed())return;
  if(!video||!video.dataset.src){fallback();return}
  clearTimers();const ticket=++attempt;mode='loading';root.dataset.playback='loading';label(true);
  if(!video.src){video.src=video.dataset.src;video.load()}
  seek();watchdog=setTimeout(()=>{if(ticket===attempt)fallback()},8000);
  try{await video.play();if(ticket!==attempt)return;if(!allowed()){stop();return}clearTimers();mode='video';autoplayBlocked=false;root.dataset.playback='video';video.classList.add('is-playing');label(true)}catch(error){if(ticket===attempt){autoplayBlocked=error.name==='NotAllowedError';fallback()}}
 };
 const sync=()=>{
  if(!allowed()){stop();return}
  if(navigator.connection?.saveData&&!userStarted){fallback();return}
  if(mode==='poster'&&root.dataset.playback==='stills')fallback();else play();
 };
 const go=(next,announce=true)=>{
  render(next,announce);pendingSeek=Number(scenes[index].dataset.start);
  video?.classList.remove('is-playing');
  if(mode==='video'&&video){seek();if(!allowed()){mode='poster';return}label(true)}
  else if(mode==='loading'){seek()}
  else if(allowed())fallback();
 };
 root.querySelector('[data-scene-prev]').addEventListener('click',()=>go(index-1));
 root.querySelector('[data-scene-next]').addEventListener('click',()=>go(index+1));
 dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i)));
 toggle.addEventListener('click',()=>{
  if(allowed()){userPaused=true;stop()}
  else{userPaused=false;userStarted=true;inView=true;play()}
 });
 root.querySelector('.nv-cinema-controls').addEventListener('keydown',event=>{
  if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();go(index+(event.key==='ArrowRight'?1:-1))}
 });
 video?.addEventListener('loadedmetadata',seek);
 video?.addEventListener('canplay',()=>{if(mode==='poster'&&allowed()&&!autoplayBlocked&&(!navigator.connection?.saveData||userStarted)){pendingSeek=Number(scenes[index].dataset.start);play()}});
 video?.addEventListener('seeked',()=>{if(mode==='video'&&allowed())video.classList.add('is-playing')});
 video?.addEventListener('timeupdate',()=>{
  if(mode!=='video'||pendingSeek!==null||video.seeking)return;
  const t=video.currentTime;let next=0;scenes.forEach((scene,i)=>{if(t>=Number(scene.dataset.cue))next=i});
  if(next!==index)render(next);
 });
 video?.addEventListener('error',fallback);
 video?.addEventListener('waiting',()=>{if(mode==='video'&&allowed()){clearTimeout(watchdog);watchdog=setTimeout(fallback,2000)}});
 video?.addEventListener('playing',()=>{if(mode==='video')clearTimeout(watchdog)});
 const observer=new IntersectionObserver(entries=>{const visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.15;if(visible!==inView){inView=visible;sync()}},{threshold:[0,.15]});observer.observe(root.querySelector('.hero-photo'));
 document.addEventListener('visibilitychange',sync);
 reduced.addEventListener('change',()=>{userStarted=false;sync()});
 root.addEventListener('shopify:block:select',event=>{const selected=scenes.findIndex(scene=>scene===event.target||scene.contains(event.target));if(selected>=0){userPaused=true;stop();go(selected,false)}});
 document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){stop();observer.disconnect()}},{once:true});
 render(0);label(false);
});
document.addEventListener('click',event=>{
 const control=event.target.closest('[data-action]');if(!control||reduced.matches)return;
 if(control.dataset.action==='gallery'||control.dataset.action==='variant'){
 const image=document.querySelector('#main-image img');image?.animate([{opacity:.55,transform:'scale(1.012)'},{opacity:1,transform:'scale(1)'}],{duration:380,easing:'cubic-bezier(.16,1,.3,1)'});
 }
 if(control.dataset.action==='edit-tab'){
 const panel=document.getElementById(control.dataset.panel);panel?.animate([{opacity:.45},{opacity:1}],{duration:280,easing:'ease-out'});
 }
});
document.querySelectorAll('[data-cart-count]').forEach(count=>new MutationObserver(()=>{if(!reduced.matches)count.animate([{transform:'scale(1)'},{transform:'scale(1.25)'},{transform:'scale(1)'}],{duration:300})}).observe(count,{childList:true}));
document.addEventListener('shopify:section:load',setupFilms);setupFilms();
})();
